import { render } from "./CourseTree.vue?vue&type=template&id=1a44905c&ts=true"
import script from "./CourseTree.vue?vue&type=script&lang=ts"
export * from "./CourseTree.vue?vue&type=script&lang=ts"

import exportComponent from "/tmp/build/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__